import { IconWrapper } from '../runtime';
export default IconWrapper('mouse', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M2.75 13.7648L2.75007 1.422C2.75007 1.1922 2.99803 1.04788 3.19785 1.16138L14.1084 7.35888C14.3618 7.50281 14.2816 7.88706 13.9918 7.9176L9.79589 8.35972L12.3779 12.8318C12.4606 12.9752 12.4115 13.1585 12.2681 13.2413L9.08425 15.0795C8.94089 15.1623 8.75757 15.1131 8.6748 14.9698L6.09283 10.4977L3.28229 13.9539C3.10429 14.1728 2.75 14.0469 2.75 13.7648Z",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});